/**
 * The two inline SVG sprites of the IDC portal design (v1.1): the official IDC logo (#idc-logo, 329x99) and the
 * status + UI line icons (#s-…). Rendered once at the app root; everything else uses <svg><use href="#…"/></svg>.
 */
import idcSprite from "../assets/idc-sprite.svg?raw";
import statusIcons from "../assets/status-icons.svg?raw";

const strip = (svg: string) => svg.replace(/<\?xml[^>]*\?>/, "").replace(/<!--[\s\S]*?-->/g, "").trim();
const SPRITES = `${strip(idcSprite)}${strip(statusIcons)}`;

/** Icon ids in the status/UI sprite, for tests and the status catalogue. */
export const ICON_IDS: readonly string[] = [...statusIcons.matchAll(/<symbol id="s-([a-z-]+)"/g)].map((m) => m[1]!);

export function Sprites() {
  // Not display:none: the logo's clipPath must stay renderable for <use> to paint it.
  return <div className="ipd-sprites" aria-hidden="true" dangerouslySetInnerHTML={{ __html: SPRITES }} />;
}

export function Icon({ name, className = "ipd-i" }: { readonly name: string; readonly className?: string }) {
  return <svg className={className} aria-hidden="true" focusable="false"><use href={`#s-${name}`} /></svg>;
}

/** The official IDC logo, reversed white on dark wherever it is used here. */
export function IdcLogo({ className }: { readonly className?: string }) {
  return <svg className={className} viewBox="0 0 329 99" role="img" aria-label="IDC"><use href="#idc-logo" /></svg>;
}
